import { Sort } from '@mui/icons-material';
import {
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { useSetAtom } from 'jotai';
import { RESET } from 'jotai/utils';
import React, { useCallback } from 'react';
import {
  SORT_MODE_AVG_DAILY_VIEWS,
  SORT_MODE_COUNTRY_POPULARITY,
  SortMode,
} from '../../../atoms/encodedFormAtoms';
import { tableSortAtom } from '../../../atoms/videoTableAtom';
import { useDemoForm } from '../../../context/DemoFormContext';

const SortBySelect: React.FC = () => {
  const { sortMode, setSortMode } = useDemoForm();
  const setTableSort = useSetAtom(tableSortAtom);

  const handleChange = useCallback(
    (event: SelectChangeEvent<SortMode>) => {
      const next = event.target.value as SortMode;
      setSortMode(next);
      // Clicking a column header switches the DataGrid into a column-driven
      // sort, which would otherwise stay in effect. Picking either sort option
      // resets that so the user always returns to a clean baseline.
      setTableSort(RESET);
    },
    [setSortMode, setTableSort],
  );

  return (
    <FormControl
      size="small"
      sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { xs: 0, sm: 260 } }}
    >
      <InputLabel id="sort-by-select-label">Primary Sort</InputLabel>
      <Select<SortMode>
        labelId="sort-by-select-label"
        id="sort-by-select"
        value={sortMode}
        label="Primary Sort"
        onChange={handleChange}
        startAdornment={
          <InputAdornment position="start" sx={{ ml: -0.5, mr: 0.5 }}>
            <Sort fontSize="small" />
          </InputAdornment>
        }
      >
        <MenuItem value={SORT_MODE_AVG_DAILY_VIEWS}>Average Daily Views</MenuItem>
        <MenuItem value={SORT_MODE_COUNTRY_POPULARITY}>Country Popularity</MenuItem>
      </Select>
    </FormControl>
  );
};

export default SortBySelect;
